import { ca } from '@cian/analytics';

export function trackCommonDealDetailsModalOpen(parentModalTitle: string, currentModalTitle: string) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'DealSalePromo',
    action: 'Show_sopr',
    label: 'popup_info',
    page: { extra: { popup: parentModalTitle, info: currentModalTitle } },
  });
}
